import React, { useEffect, useState } from 'react'
import { getDevicesByOrganization } from '../../../../../api/devicesApi'
import Multiview from '../Multiview'
import {KTSVG} from '../../../../../_metronic/helpers'
import { useAuth } from '../../../../modules/auth/core/Auth'
import { GridConfiguratorModal } from '../../../../../_metronic/partials/modals/grid-configurator/GridConfigurator'
import './MultiviewPage.css'

interface StreamData {
  sessionId: string
  isInitiator: boolean
  name: string
}

const MultiviewPage: React.FC = () => {
  const { activeOrganization } = useAuth()
  const [streams, setStreams] = useState<StreamData[]>([])
  const [gridLayout, setGridLayout] = useState<number>(12)
  const [selectedStreams, setSelectedStreams] = useState<StreamData[]>([])

  // Modale di configurazione
  const [showConfigModal, setShowConfigModal] = useState(false)

  // Stato fullscreen del browser
  const [isFullscreen, setIsFullscreen] = useState(false)

  // Stato che nasconde l’UI Metronic, lasciando solo la griglia
  const [gridOnly, setGridOnly] = useState(false)

  // Al mount, carica i device
  useEffect(() => {
    async function fetchDevices() {
      if (activeOrganization) {
        try {
          const devices = await getDevicesByOrganization(activeOrganization.ID_Organizzazione)
          const streamsData: StreamData[] = devices.map((device: any) => ({
            sessionId: device.Android_ID.toString(),
            isInitiator: false,
            name: device.Nome,
          }))
          console.log('Debug availableDevices:', streamsData)
          setStreams(streamsData)
        } catch (error) {
          console.error(error)
        }
      }
    }
    fetchDevices()
  }, [activeOrganization])

  // Listener che scatta ogni volta che si entra/esce dal fullscreen (anche con ESC)
  useEffect(() => {
    function handleFsChange() {
      const nowFullscreen = !!document.fullscreenElement
      setIsFullscreen(nowFullscreen)
      if (!nowFullscreen) {
        // Se l'utente esce dal fullscreen (magari con ESC), disattiva la gridOnly
        setGridOnly(false)
      }
    }
    document.addEventListener('fullscreenchange', handleFsChange)
    return () => document.removeEventListener('fullscreenchange', handleFsChange)
  }, [])

  // Aggiorna la classe “grid-only-mode” sul body per nascondere sidebar, navbar, ecc.
  useEffect(() => {
    if (gridOnly) {
      document.body.classList.add('grid-only-mode')
    } else {
      document.body.classList.remove('grid-only-mode')
    }
  }, [gridOnly])

  // Callback dal modal di configurazione
  const handleConfigured = (layout: number, chosen: string[] | 'random') => {
    setGridLayout(layout)

    if (chosen === 'random') {
      const total = streams.length
      const realAmount = Math.min(layout, total)
      const shuffled = [...streams].sort(() => 0.5 - Math.random())
      const randomDevices = shuffled.slice(0, realAmount)
      setSelectedStreams(randomDevices)
    } else {
      // Filtra i device corrispondenti ai sessionId scelti
      const chosenDevices = streams.filter((s) => chosen.includes(s.sessionId))
      setSelectedStreams(chosenDevices)
    }
  }

  // Toggle “grid + fullscreen”
  // - se non siamo in fullscreen => entra (requestFullscreen) e gridOnly = true
  // - se siamo in fullscreen => esci (exitFullscreen) e gridOnly = false
  const toggleGridFullscreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen()
      setGridOnly(true)
    } else {
      document.exitFullscreen()
      setGridOnly(false)
    }
  }

  return (
    <div style={{ padding: gridOnly ? 0 : '1rem' }}>
      {/* Pulsante "CONFIGURA GRIGLIA", visibile solo se NON stiamo in gridOnly */}
      {!gridOnly && (
        <button
          onClick={() => setShowConfigModal(true)}
          className='btn btn-primary mb-5'
        >
          CONFIGURA GRIGLIA
        </button>
      )}

      {/* Modale configurazione */}
      <GridConfiguratorModal
        show={showConfigModal}
        onClose={() => setShowConfigModal(false)}
        availableDevices={streams.map((s) => ({
          id: s.sessionId,
          name: s.name,
        }))}
        onConfigured={handleConfigured}
      />

      {/* Griglia vera e propria */}
      <Multiview streams={selectedStreams} gridLayout={gridLayout} />

      {/* Pulsante “FS”: se siamo già in fullscreen, lo mostriamo comunque 
          volendo potresti nasconderlo quando isFullscreen = true. */}
      <button
        onClick={toggleGridFullscreen}
        style={{
          position: 'fixed',
          bottom: '20px',
          right: '20px',
          borderRadius: '50%',
          width: '50px',
          height: '50px',
          zIndex: 9999,
          backgroundColor: '#2DAB66',
          color: 'white',
          border: 'none',
          cursor: 'pointer',
        }}
      >
        {isFullscreen ? (
        // Se siamo già in fullscreen, mostra l'icona compress-solid
        <KTSVG path='/media/icons/duotune/others/compress-solid.svg' className='svg-icon-1' />
        ) : (
        // Altrimenti, se non siamo in fullscreen, mostra expand-solid
        <KTSVG path='/media/icons/duotune/others/expand-solid.svg' className='svg-icon-1' />
        )}
      </button>
    </div>
  )
}

export default MultiviewPage